var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolOnline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9997 7H6.99967C5.762 7 4.57501 7.49167 3.69984 8.36683C2.82467 9.242 2.33301 10.429 2.33301 11.6667V18.6667H6.99967V11.6667H48.9997V44.3333H32.6663V49H48.9997C50.2374 49 51.4243 48.5083 52.2995 47.6332C53.1747 46.758 53.6663 45.571 53.6663 44.3333V11.6667C53.6663 10.429 53.1747 9.242 52.2995 8.36683C51.4243 7.49167 50.2374 7 48.9997 7ZM2.33301 42V49H9.33301C9.33301 47.1435 8.59551 45.363 7.28275 44.0503C5.97 42.7375 4.18952 42 2.33301 42ZM2.33301 32.6667V37.3333C3.8651 37.3333 5.38218 37.6351 6.79765 38.2214C8.21311 38.8077 9.49924 39.6671 10.5826 40.7504C11.6659 41.8338 12.5253 43.1199 13.1116 44.5354C13.6979 45.9508 13.9997 47.4679 13.9997 49H18.6663C18.6663 44.6681 16.9455 40.5137 13.8824 37.4506C10.8193 34.3875 6.66488 32.6667 2.33301 32.6667ZM2.33301 23.3333V28C5.09077 28 7.82152 28.5432 10.3694 29.5985C12.9172 30.6539 15.2322 32.2007 17.1823 34.1508C19.1323 36.1008 20.6791 38.4158 21.7345 40.9636C22.7898 43.5115 23.333 46.2422 23.333 49H27.9997C27.9997 34.8133 16.4963 23.3333 2.33301 23.3333ZM25.6663 25.8767V30.5433L33.833 35L41.9997 30.5433V25.8767L33.833 30.3333L25.6663 25.8767ZM33.833 14L20.9997 21L33.833 28L46.6663 21L33.833 14Z",
    fill: "url(#paint0_linear_3569_10333)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3569_10333",
    x1: 53.6663,
    y1: 28,
    x2: 2.33301,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37384B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolOnline);
export default __webpack_public_path__ + "static/media/school-online.79c9d7cc923891891334b274d4462ba6.svg";
export { ForwardRef as ReactComponent };